import type { BeforeSendFn } from 'posthog-js';

const NEXT_STATIC = '/_next/static/';

type ExceptionFrame = { filename?: string };
type ExceptionEntry = { stacktrace?: { frames?: ExceptionFrame[] } };

// Chrome iOS injects third-party scripts whose exceptions carry no app frame.
// Drop those; keep every other browser, event and any exception with an app frame.
export const beforeSend: BeforeSendFn = (event) => {
  if (!event || event.event !== '$exception') {
    return event;
  }
  if (typeof navigator === 'undefined' || !navigator.userAgent.includes('CriOS')) {
    return event;
  }
  const list: ExceptionEntry[] = event.properties?.$exception_list ?? [];
  const hasAppFrame = list.some((entry) =>
    entry.stacktrace?.frames?.some((frame) => frame.filename?.includes(NEXT_STATIC)),
  );
  return hasAppFrame ? event : null;
};
